import axiosInstance from '../../../config/axiosInstance';
const  SaleOrderService = {
    async GetAllSaleOrderPayment(redirectCallback,SaleOrderID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SaleOrder/GetSaleOrderPayment?SaleOrderID=${SaleOrderID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllPaymentMethod(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SaleOrder/GetPaymentMethod`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteSaleOrderPayment(ID,redirectCallback) {
        try {
           const response = await axiosInstance.get(`/SaleOrder/DeleteSaleOrderPayment?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default SaleOrderService;